export const playerSetupKey = ["player-setup"] as const

export type PlayerSetupStepStatus = "completed" | "skipped" | "in_progress" | "not_started" | string

export interface PlayerSetupStep {
  id: string
  title: string
  status: PlayerSetupStepStatus
  scoreLabel?: string | null
}

/** Progress an agent or the player sees on the overview. */
export interface PlayerSetupProgress {
  started: boolean
  done: number
  total: number
  remaining: number
  steps: PlayerSetupStep[]
  scoreLabels: string[]
  resumeStep?: string | null
  hasAccount: boolean
  consents?: PlayerSetupConsents
}

export interface PlayerSetupConsents {
  publicCareer: boolean
  whoop: boolean
  motivation: boolean
  aiAssistant: boolean
  improveModels: boolean
}

export interface PlayerSetupAgent {
  id: string
  fullName?: string | null
  email: string
  since?: string | null
}

/** Full setup returned by /api/player-setup. */
export interface PlayerSetupDetail extends PlayerSetupProgress {
  playerId: string
  firstName: string
  birthDate?: string | null
  age?: number | null
  adult: boolean
  termsCurrent: boolean
  agents: PlayerSetupAgent[]
  consents: PlayerSetupConsents
  financial: {
    netMonthlyIncome?: number | null
    monthlySavings?: number | null
    liquidWealth?: number | null
  }
  whoopConnected: boolean
  whoopLoading: boolean
  instagramConnected: boolean
  instagramUsername?: string | null
}

export const PLAYER_INTRO_STEPS = [
  "player_birth_terms",
  "player_agent_access",
  "player_consents",
] as const

export function joinLabels(items: string[]): string {
  if (items.length <= 1) return items[0] ?? ""
  if (items.length === 2) return `${items[0]} and ${items[1]}`
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`
}

export function ageFromIso(iso: string, today = new Date()): number | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso)
  if (!match) return null
  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const probe = new Date(year, month - 1, day)
  if (probe.getFullYear() !== year || probe.getMonth() !== month - 1 || probe.getDate() !== day) return null
  let years = today.getFullYear() - year
  if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) years -= 1
  return years
}
